
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 20.03c-7.8 0-12-5.7-12-8.03s4.2-8.03 12-8.03S24 9.67 24 12s-4.2 8.03-12 8.03zm0-15.06C4.78 4.97 1 10.19 1 12s3.78 7.03 11 7.03S23 13.81 23 12s-3.78-7.03-11-7.03z"}}),_c('path',{attrs:{"d":"M12 16.56A4.56 4.56 0 1116.56 12 4.56 4.56 0 0112 16.56zm0-8.12A3.56 3.56 0 1015.56 12 3.56 3.56 0 0012 8.44z"}})])
          )
        }
      }
    